/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Deduction_Audit_DescriptionInputs */

const en_cargos_deduction_audit_description = /** @type {(inputs: Cargos_Deduction_Audit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders and inventory events linked to this cargo.`)
};

const es_cargos_deduction_audit_description = /** @type {(inputs: Cargos_Deduction_Audit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos y eventos de inventario vinculados a esta carga.`)
};

/**
* | output |
* | --- |
* | "Orders and inventory events linked to this cargo." |
*
* @param {Cargos_Deduction_Audit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_deduction_audit_description = /** @type {((inputs?: Cargos_Deduction_Audit_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Deduction_Audit_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_deduction_audit_description(inputs)
	return es_cargos_deduction_audit_description(inputs)
});